import Select from 'react-select'
import React from 'react';
import {useTranslation} from 'react-i18next';
import selectFilterStyles from '../../util/selectFilterStyles';
import getStyledSelectIndicatorsContainer from '../../util/getStyledSelectIndicatorsContainer';
import useCheckFilterFieldsValidity from '../../util/useCheckFilterFieldsValidity';
import Filter from './Filter';
import checkOtherFiltersValid from '../../util/checkOtherFiltersValid';

const FilterSingleSelectDropdown = (props) => {
    const {t} = useTranslation();
    const checkFieldsValidity = useCheckFilterFieldsValidity();
    return <Filter
        key={`filter-${props.filter.name}`}
        filters={props.filters}
        setFilters={props.setFilters}
        filter={props.filter}
        loading={props.loading}
        filtersInitial={props.filtersInitial}
    >
        <Select
            id={`filter-${props.filter.name}`}
            noOptionsMessage={() => t('Select.noOptionsMessage')}
            loadingMessage={() => t('Select.loadingMessage')}
            placeholder={t('Select.placeholder')}
            isDisabled={props.loading}
            scrollIntoView={true}
            styles={selectFilterStyles(props.filter)}
            value={
                (() => {
                    if (props.filter.value === null) {
                        return null
                    }

                    for (const option of props.filter.config.options) {
                        if (props.filter.value === option) {
                            return {value: option, label: props.APIOptions[option]}
                        }
                    }
                })()
            }
            options={props.filter.config.options.map((option) => {
                return {
                    value: option,
                    label: props.APIOptions[option]
                }
            })}
            onChange={
                (value) => {
                    const othersValid = checkOtherFiltersValid(props.filter, props.filters);
                    const filterValidity = checkFieldsValidity(value ? value.value : null, props.filter.validation);

                    props.setFilters({
                        ...props.filters,
                        changed: true,
                        valid: filterValidity.valid && othersValid,
                        filters: {
                            ...props.filters.filters,
                            [props.filter.name]: {
                                ...props.filters.filters[props.filter.name],
                                value: value ? value.value : null,
                                valid: filterValidity.valid,
                                touched: true,
                                errors: filterValidity.errors
                            }
                        }
                    });
                }
            }
            onFocus={
                (event) => {
                    event.target.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
                }
            }
            components={
                {
                    IndicatorsContainer:
                        getStyledSelectIndicatorsContainer()
                }
            }
        />
    </Filter>
}

export default FilterSingleSelectDropdown;
